import { snapToRemainingPercentage } from '@payaca/helpers/paymentScheduleHelper';
import { getStoredPercentageDue } from '@payaca/helpers/storedPaymentSchedule';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { PaymentScheduleFormValues } from './types';

/**
 * Binds a stage's percentage. Pass the result to
 * `PaymentScheduleStage.PercentageField`, and to anything else that sets the
 * percentage. `onChange` takes a percentage that matches the remainder the
 * editor shows as the exact remainder; `onExactChange` sets the value as given,
 * for a percentage worked out from an amount.
 */
export const useStagePercentageField = (
  index: number,
  stageType: 'deposit' | 'instalment'
) => {
  const { control } = useFormContext<PaymentScheduleFormValues>();
  const { field } = useController({
    name:
      stageType === 'deposit'
        ? `paymentSchedule.stages.${index}.basis.percentageDue`
        : `paymentSchedule.stages.${index}.percentageDue`,
    control,
  });
  const stages = useWatch({ control, name: 'paymentSchedule.stages' });

  const onChange = (value: number | null) =>
    field.onChange(
      value === null
        ? null
        : snapToRemainingPercentage(
            value,
            stages
              .filter((_, stageIndex) => stageIndex !== index)
              .map((stage) => ({
                percentageDue: getStoredPercentageDue(stage),
              }))
          )
    );

  return { ...field, onChange, onExactChange: field.onChange };
};
